<template>
  <div class="flex justify-between px-4 py-1">
    <span
      v-for="(day, i) in weekdays"
      :key="i"
      class="text-situational-grey w-full text-center text-xs font-medium uppercase"
    >
      {{ day }}
    </span>
  </div>
</template>

<script setup lang="ts">
  import { useI18n } from 'vue-i18n';

  const { t } = useI18n();
  const weekdays = [
    t('searchFormCalendar.weekDays.monday'),
    t('searchFormCalendar.weekDays.tuesday'),
    t('searchFormCalendar.weekDays.wednesday'),
    t('searchFormCalendar.weekDays.thursday'),
    t('searchFormCalendar.weekDays.friday'),
    t('searchFormCalendar.weekDays.saturday'),
    t('searchFormCalendar.weekDays.sunday'),
  ];
</script>

<i18n src="../locales.json"></i18n>
